import { B as u, u as n } from "./export-cdcbfb2b.js";
var r = u, a = n, o = function(f, t, e) {
  return e.get && r(e.get, t, { getter: !0 }), e.set && r(e.set, t, { setter: !0 }), a.f(f, t, e);
};
export {
  o as d
};
